import React from "react";
import Container from "../common/styles/Container";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as List from "../../../../../../common-deprecated/styles/v2/toyota/globals/List";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { useBnbSelector } from "../../../redux/store";
import useLease from "../../../hooks/buy/useLease";
import * as Styles from "./styles/Lease";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_LEASE_TERMS } from "../../../utils/modalConstants";
import { leaseCar } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import LeasePanel from "./LeasePanel";
import { trackCtaCheckout } from "../../../utils/tracking";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const LeaseView = (): JSX.Element => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const { labels, enableTermsConditions } = useLease();

    const [leaseDescriptionLabel, leaseDescriptionMonthlyLabel] = useBnbOptionalLabel([
        "leaseDescription",
        "leaseDescriptionMonthly",
    ]);
    const description =
        financeOption === "monthly" && leaseDescriptionMonthlyLabel
            ? "leaseDescriptionMonthly"
            : leaseDescriptionLabel
              ? "leaseDescription"
              : null;

    const onLeaseCar = (): void => {
        trackCtaCheckout(NavStep.Lease, "online-retailing-checkout-leasing");
        dispatch(leaseCar());
    };

    const openConditionsModal = (event: React.MouseEvent): void => {
        event.preventDefault();
        dispatch(showModal({ type: MODAL_LEASE_TERMS }));
    };
    return (
        <>
            <Styles.Wrapper hasBackground>
                <Container maxWidth={{ _: "none", lg: 750 }}>
                    <Flex.Row>
                        <Flex.Col width={{ _: 1, lg: 1 / 2 }}>
                            <Styles.Title>
                                <BnbLabel
                                    label={financeOption === "cash" ? "leaseTitle" : "leaseTitleMonthly"}
                                    fallbackLabel="leaseTitle"
                                />
                            </Styles.Title>

                            {description && (
                                <Styles.Description>
                                    <BnbLabel label={description} useHTML />
                                </Styles.Description>
                            )}

                            <List.BulletList>
                                {labels.map((item) => (
                                    <List.BulletListItem key={item.icon}>
                                        {item.extraInfo || item.extraText ? (
                                            <>
                                                <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                                <Popover showOnClick content={item.extraInfo} />
                                                <span dangerouslySetInnerHTML={{ __html: item.extraText || "" }} />
                                            </>
                                        ) : (
                                            <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                        )}
                                    </List.BulletListItem>
                                ))}
                            </List.BulletList>

                            {enableTermsConditions && (
                                <Button.Link onClick={openConditionsModal}>
                                    <Text.Button>
                                        <BnbLabel
                                            label={
                                                financeOption === "cash"
                                                    ? "leaseTermsConditionsLink"
                                                    : "leaseTermsConditionsLinkMonthly"
                                            }
                                            fallbackLabel="leaseTermsConditionsLink"
                                        />
                                    </Text.Button>
                                </Button.Link>
                            )}
                        </Flex.Col>

                        <Styles.Sidebar width={{ _: 1, lg: 1 / 2 }}>
                            <LeasePanel leaseCar={onLeaseCar} />
                        </Styles.Sidebar>
                    </Flex.Row>
                </Container>
            </Styles.Wrapper>

            <div>
                <Container>
                    <DisclaimerContainer />
                </Container>
            </div>
        </>
    );
};

export default LeaseView;
